export default __webpack_public_path__ + "images/c7f12860883eaee1b186707a0f9cc7da-7_mobile_659x494.jpg";